export default __webpack_public_path__ + "static/media/event-complete.f6b5c4ce.svg";